/* Materparade: intestazione e menu a schermo intero */
(function () {
  'use strict';
  var root = document.documentElement;
  function init() {
    var hdr = document.querySelector('[data-mp-hdr]');
    if (!hdr || hdr._mp) return;
    hdr._mp = true;
    var menu = hdr.querySelector('[data-mp-menu]');
    var openBtn = hdr.querySelector('[data-mp-menu-open]');
    var closeBtn = hdr.querySelector('[data-mp-menu-close]');
    var searchBtn = hdr.querySelector('[data-mp-search]');
    var input = hdr.querySelector('[data-mp-search-input]');
    var links = [].slice.call(hdr.querySelectorAll('.mp-menu__link'));
    var last = 0, lastFocus = null;

    menu.tabIndex = -1;
    var syncH = function () { root.style.setProperty('--header-height', hdr.offsetHeight + 'px'); };
    syncH(); window.addEventListener('resize', syncH);

    function setOpen(o, focusSearch) {
      menu.classList.toggle('is-open', o);
      menu.inert = !o;
      menu.setAttribute('aria-hidden', o ? 'false' : 'true');
      root.classList.toggle('mp-menu-open', o);
      openBtn.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (o) {
        lastFocus = document.activeElement;
        hdr.classList.remove('is-hidden');
        /* il focus va al contenitore (senza anello); alla ricerca solo se richiesta */
        setTimeout(function () { (focusSearch && input ? input : menu).focus({ preventScroll: true }); }, 380);
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus({ preventScroll: true });
      }
    }
    openBtn.addEventListener('click', function () { setOpen(true, false); });
    closeBtn.addEventListener('click', function () { setOpen(false); });
    if (searchBtn) searchBtn.addEventListener('click', function () { setOpen(true, true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false); });
    menu.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) setOpen(false); });

    links.forEach(function (a) {
      function tint() { menu.style.setProperty('--mc', a.getAttribute('data-color')); }
      a.addEventListener('mouseenter', tint);
      a.addEventListener('focus', tint);
    });
    if (links[0]) menu.style.setProperty('--mc', links[0].getAttribute('data-color'));

    function onScroll() {
      var y = window.scrollY || root.scrollTop;
      hdr.classList.toggle('is-scrolled', y > 24);
      if (root.classList.contains('mp-menu-open')) { last = y; return; }
      if (y > last + 4 && y > 240) hdr.classList.add('is-hidden');
      else if (y < last - 4 || y < 240) hdr.classList.remove('is-hidden');
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();